<template>
    <span>Page not found. Go back <router-link to="/">home</router-link>?</span>
</template>

<script>
    // import VueRouter from 'vue-router'

    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>